import { render, staticRenderFns } from "./CertificadoWrapper.vue?vue&type=template&id=96774a88"
import script from "./CertificadoWrapper.vue?vue&type=script&lang=js"
export * from "./CertificadoWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports